import React, { useState, useContext } from 'react';
import { SchoolContext } from '../../context/SchoolContext';
import Card from '../ui/Card';
import Input from '../ui/Input';
import Button from '../ui/Button';

const SchoolManagement = () => {
    const { school, setSchool } = useContext(SchoolContext);
    const [isEditing, setIsEditing] = useState(false);

    const [formState, setFormState] = useState(
        school || {
            name: '',
            location: '',
            type: 'Private',
            primaryColor: '#3b82f6',
            secondaryColor: '#60a5fa',
        }
    );

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormState(prevState => ({ ...prevState, [name]: value }));
    };

    const handleCreateOrSave = (e) => {
        e.preventDefault();
        setSchool(formState);
        setIsEditing(false);
    };
    
    const handleEdit = () => {
        setFormState(school);
        setIsEditing(true);
    };

    const handleCancel = () => {
        setIsEditing(false);
        if (school) {
            setFormState(school);
        }
    };

    if (!school || isEditing) {
        return (
            <Card title={!school ? "Register Your School" : "Edit School Details"}>
                 <p className="mb-6 text-gray-600">
                     {!school ? "Provide the following information to get your school registered." : "Update your school's information below."}
                 </p>
                <form onSubmit={handleCreateOrSave}>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-4">
                        <div>
                            <label className="block text-gray-700 text-sm font-bold mb-1">School Name</label>
                            <Input type="text" name="name" placeholder="e.g., Greenwood High" value={formState.name} onChange={handleInputChange} required />
                        </div>
                        <div>
                            <label className="block text-gray-700 text-sm font-bold mb-1">Location</label>
                            <Input type="text" name="location" placeholder="e.g., Springfield, USA" value={formState.location} onChange={handleInputChange} required/>
                        </div>
                        <div>
                            <label className="block text-gray-700 text-sm font-bold mb-1">School Type</label>
                             <select name="type" value={formState.type} onChange={handleInputChange} className="w-full px-4 py-2 mt-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-600">
                                 <option>Public</option>
                                 <option>Private</option>
                                 <option>Charter</option>
                             </select>
                        </div>
                         <div>
                             <label className="block text-gray-700 text-sm font-bold mb-1">Primary Color</label>
                             <div className="flex items-center space-x-2 mt-2">
                                <input type="color" name="primaryColor" value={formState.primaryColor} onChange={handleInputChange} className="w-10 h-10 p-0 border-none rounded-full cursor-pointer"/>
                                <span className="px-3 py-2 border rounded-md bg-gray-50">{formState.primaryColor}</span>
                             </div>
                        </div>
                         <div>
                            <label className="block text-gray-700 text-sm font-bold mb-1">Secondary Color</label>
                             <div className="flex items-center space-x-2 mt-2">
                                <input type="color" name="secondaryColor" value={formState.secondaryColor} onChange={handleInputChange} className="w-10 h-10 p-0 border-none rounded-full cursor-pointer"/>
                                <span className="px-3 py-2 border rounded-md bg-gray-50">{formState.secondaryColor}</span>
                             </div>
                        </div>
                    </div>
                     <div className="flex space-x-2">
                        <Button type="submit">{isEditing ? "Save Changes" : "Create School"}</Button>
                        {isEditing && <button type="button" onClick={handleCancel} className="px-6 py-2 mt-4 text-gray-700 bg-gray-200 rounded-lg hover:bg-gray-300">Cancel</button>}
                    </div>
                </form>
            </Card>
        );
    }
    
    return (
        <Card title="School Details">
             <div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                    <div><p className="text-sm text-gray-500">School Name</p><p className="text-lg font-semibold">{school.name}</p></div>
                    <div><p className="text-sm text-gray-500">Location</p><p className="text-lg">{school.location}</p></div>
                    <div><p className="text-sm text-gray-500">School Type</p><p className="text-lg">{school.type}</p></div>
                    <div className="flex items-center space-x-4">
                        <div>
                            <p className="text-sm text-gray-500">Primary Color</p>
                            <div className="w-10 h-10 rounded-full border border-gray-200" style={{ backgroundColor: school.primaryColor }}></div>
                        </div>
                        <div>
                            <p className="text-sm text-gray-500">Secondary Color</p>
                            <div className="w-10 h-10 rounded-full border border-gray-200" style={{ backgroundColor: school.secondaryColor }}></div>
                        </div>
                    </div>
                </div>
                <Button onClick={handleEdit}>Edit Details</Button>
            </div>
        </Card>
    );
};

export default SchoolManagement;
